import { FinancialVendor } from ".";

export class Vendor {
    id: number;
    name: string;
    displayText: string;
    doingBusinessAsName: string;
    isActive: boolean;
    marketFinancialVendor: FinancialVendor;
    financialVendors: FinancialVendor[];
}
